import { CForm, CFormInput, CButton, CFormLabel, CInputGroup, CInputGroupText } from '@coreui/react';
import React from 'react';
import styles from './FormLogin.module.css';
import { AuthContext } from '../../context/AuthContext';



const FormLogin = () => {

  const { signIn } = React.useContext(AuthContext);
  const [showPassword, setShowPassword] = React.useState(false);
  const [isValid, setIsValid] = React.useState();
  const [form, setForm] = React.useState({
    email: null,
    password: null
  });

  const onChangeInput = (evt) => {
    const { name, value } = evt.target;
    setForm({ ...form, [name]: value });
  };
  const handleSubmit = (evt) => {
    evt.preventDefault();
    signIn(form);
  };

  React.useEffect(() => {
    form.email !== null && form.password !== null ? setIsValid(true) : setIsValid(false);
  }, [form]);


  
  return (
    <CForm className="text-left justify-content-start" onSubmit={handleSubmit}>
      <CFormLabel className={styles['customLabel-left']}>Email</CFormLabel>
      <CFormInput type="email" id="email" name="email" className="mb-3" onChange={onChangeInput} />
      <CFormLabel className={styles['customLabel-left']}>Contraseña</CFormLabel>
      <CInputGroup className="mb-3">
        <CFormInput
          type={showPassword ? 'text' : 'password'}
          id="password"
          name="password"
          onChange={onChangeInput}
        />
        <CInputGroupText
          role="button"
          tabIndex={0}
          aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
          style={{ cursor: 'pointer' }}
          onClick={() => setShowPassword((v) => !v)}
          onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && setShowPassword((v) => !v)}>
          {showPassword ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16"><path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"/><path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"/><path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"/></svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16"><path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/><path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.817 8a3.178 3.178 0 0 1 .654-1.924A3.48 3.48 0 0 1 8 5c.932 0 1.786.376 2.41.992A3.178 3.178 0 0 1 11.183 8a3.178 3.178 0 0 1-.654 1.924A3.48 3.48 0 0 1 8 11c-.932 0-1.786-.376-2.41-.992A3.177 3.177 0 0 1 4.817 8z"/></svg>
          )}
        </CInputGroupText>
      </CInputGroup>
      <CButton type="submit" className="generalBtn" disabled={!isValid}>
        Iniciar sesion
      </CButton>
    </CForm>
  );
};

export default FormLogin;
